import { Actions } from '../constants';

export function toggleLanguage() {
  return {
    type: Actions.TOGGLE_DESCRIPTION_LANGUAGE,
  };
}
